/*
 * @Author: renming-lj 2982488597@qq.com
 * @Date: 2024-05-13 16:41:45
 * @LastEditors: renming-lj 2982488597@qq.com
 * @LastEditTime: 2024-05-15 13:41:50
 * @FilePath: \backstage\src\main.js
 * @Description: 入口文件
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
